import Field from '@/components/common/Field/Field';
import * as S from './style';
import InputText from '@/components/common/Input/InputText/InputText';
import { useState } from 'react';
import InputSelect from '@/components/common/Input/InputSelect/InputSelect';

import { emailOptions } from '@/constants/option';
import { useFindMemeberPasswordApi, usePostSendEmailVerificationApi, usePostVerifyCodeApi } from '@/api/auth';
import { useModalStore } from '@/store/modalStore';
import { useNavigate } from 'react-router-dom';
const FindPw = () => {
	const navigate = useNavigate();
	const { showModal } = useModalStore();
	const [id, setId] = useState('');
	const [email, setEmail] = useState({ front: '', back: '', code: '직접입력', verificationCode: '' });
	const [isEmailVerified, setIsEmailVerified] = useState(false);
	const [isSendEmail, setIsSendEmail] = useState(false);
	const { mutateAsync: VerifyCode } = usePostVerifyCodeApi();
	const { mutateAsync: SendEmailVerification, isPending } = usePostSendEmailVerificationApi();
	const { mutateAsync: findMemberPw } = useFindMemeberPasswordApi();

	const handleSendEmailVerification = async () => {
		const res = await SendEmailVerification({ email: `${email.front}@${email.back}` });
		if (res.data.success) {
			showModal('입력하신 이메일로 인증번호가 발송되었습니다.\n이메일을 확인하신 후 인증번호를 입력해 주세요.');
		}
		setIsSendEmail(true);
	};
	const hanldeVerifyCode = async () => {
		const emailResult = `${email.front}@${email.back}`;
		const res = await VerifyCode({ email: emailResult, code: email.verificationCode });
		if (res.data.success) {
			showModal('인증이 완료되었습니다.');
			setIsEmailVerified(true);
		} else {
			showModal('인증번호가 일치하지 않습니다.');
			setIsEmailVerified(false);
		}
	};
	const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const res = await findMemberPw({ member_id: id, member_email: `${email.front}@${email.back}` });
		if (res.data.success) {
			navigate('/auth/findpw/modify', {
				state: {
					member_id: id,
				},
			});
		} else {
			showModal('해당 아이디로 등록된 이메일과 일치하지 않습니다.');
		}
	};

	return (
		<main>
			<S.Container onSubmit={onSubmit}>
				<div className="title">비밀번호 찾기</div>
				<S.FieldBox>
					<Field title="아이디" error="">
						<InputText
							placeholder="아이디 입력"
							value={id}
							input={(e: React.ChangeEvent<HTMLInputElement>) => {
								setId(e.target.value);
							}}
						/>
					</Field>
					<Field title="이메일 인증" gap="0.8rem">
						<Field>
							<S.FlexRow>
								<InputText
									input={(e: React.ChangeEvent<HTMLInputElement>) => {
										setEmail((prev) => ({ ...prev, front: e.target.value }));
										setIsSendEmail(false);
									}}
									value={email.front}
								/>
								@
								<InputText
									input={(e: React.ChangeEvent<HTMLInputElement>) => {
										setEmail((prev) => ({ ...prev, back: e.target.value }));
										setIsSendEmail(false);
									}}
									value={email.code !== '' && email.code !== '직접입력' ? email.code : email.back}
									readonly={email.code !== '' && email.code !== '직접입력'}
								/>
								<InputSelect
									options={emailOptions}
									selectedOption={email.code}
									setSelectedOption={(val) => {
										setEmail((prev) => ({ ...prev, code: val }));
										setIsSendEmail(false);

										if (val !== '직접입력') {
											setEmail((prev) => ({ ...prev, back: val }));
										}
									}}
									defaultValue="직접입력"
								/>
								<S.FindButton
									type="button"
									onClick={handleSendEmailVerification}
									disabled={email.front === '' || email.back === '' || email.code === '' || isPending}
								>
									{!isSendEmail ? '전송' : '재전송'}
								</S.FindButton>
							</S.FlexRow>
							<S.FlexRow>
								<InputText
									value={email.verificationCode}
									input={(e: React.ChangeEvent<HTMLInputElement>) => {
										setEmail((prev) => ({ ...prev, verificationCode: e.target.value }));
										setIsEmailVerified(false);
									}}
									placeholder="인증번호 입력"
								/>
								<S.FindButton type="button" onClick={hanldeVerifyCode} disabled={email.verificationCode === '' || isEmailVerified}>
									인증
								</S.FindButton>
							</S.FlexRow>
							<S.Danger>※ 이메일 인증의 경우 받는 메일서버에 따라 도착이 지연되거나 스팸으로 분류될 수 있습니다.</S.Danger>
						</Field>
					</Field>
					<S.Button
						disabled={id === '' || email.front === '' || email.back === '' || email.code === '' || email.verificationCode === '' || !isEmailVerified}
						type="submit"
					>
						비밀번호 찾기
					</S.Button>
				</S.FieldBox>
			</S.Container>
		</main>
	);
};
export default FindPw;
